/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateCustomDetectionRuleRequestBody,
  CreateCustomDetectionRuleRequestBody$Outbound,
  CreateCustomDetectionRuleRequestBody$outboundSchema,
} from "../components/createcustomdetectionrulerequestbody.js";

export type CreateCustomDetectionRuleSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateCustomDetectionRuleSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateCustomDetectionRuleSecurity = {
  option1?: CreateCustomDetectionRuleSecurityOption1 | undefined;
  option2?: CreateCustomDetectionRuleSecurityOption2 | undefined;
};

export type CreateCustomDetectionRuleRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createCustomDetectionRuleRequestBody: CreateCustomDetectionRuleRequestBody;
};

/** @internal */
export type CreateCustomDetectionRuleSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateCustomDetectionRuleSecurityOption1$outboundSchema:
  z.ZodMiniType<
    CreateCustomDetectionRuleSecurityOption1$Outbound,
    CreateCustomDetectionRuleSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function createCustomDetectionRuleSecurityOption1ToJSON(
  createCustomDetectionRuleSecurityOption1:
    CreateCustomDetectionRuleSecurityOption1,
): string {
  return JSON.stringify(
    CreateCustomDetectionRuleSecurityOption1$outboundSchema.parse(
      createCustomDetectionRuleSecurityOption1,
    ),
  );
}

/** @internal */
export type CreateCustomDetectionRuleSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateCustomDetectionRuleSecurityOption2$outboundSchema:
  z.ZodMiniType<
    CreateCustomDetectionRuleSecurityOption2$Outbound,
    CreateCustomDetectionRuleSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function createCustomDetectionRuleSecurityOption2ToJSON(
  createCustomDetectionRuleSecurityOption2:
    CreateCustomDetectionRuleSecurityOption2,
): string {
  return JSON.stringify(
    CreateCustomDetectionRuleSecurityOption2$outboundSchema.parse(
      createCustomDetectionRuleSecurityOption2,
    ),
  );
}

/** @internal */
export type CreateCustomDetectionRuleSecurity$Outbound = {
  Option1?: CreateCustomDetectionRuleSecurityOption1$Outbound | undefined;
  Option2?: CreateCustomDetectionRuleSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CreateCustomDetectionRuleSecurity$outboundSchema: z.ZodMiniType<
  CreateCustomDetectionRuleSecurity$Outbound,
  CreateCustomDetectionRuleSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CreateCustomDetectionRuleSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CreateCustomDetectionRuleSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function createCustomDetectionRuleSecurityToJSON(
  createCustomDetectionRuleSecurity: CreateCustomDetectionRuleSecurity,
): string {
  return JSON.stringify(
    CreateCustomDetectionRuleSecurity$outboundSchema.parse(
      createCustomDetectionRuleSecurity,
    ),
  );
}

/** @internal */
export type CreateCustomDetectionRuleRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateCustomDetectionRuleRequestBody:
    CreateCustomDetectionRuleRequestBody$Outbound;
};

/** @internal */
export const CreateCustomDetectionRuleRequest$outboundSchema: z.ZodMiniType<
  CreateCustomDetectionRuleRequest$Outbound,
  CreateCustomDetectionRuleRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createCustomDetectionRuleRequestBody:
      CreateCustomDetectionRuleRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      createCustomDetectionRuleRequestBody:
        "CreateCustomDetectionRuleRequestBody",
    });
  }),
);

export function createCustomDetectionRuleRequestToJSON(
  createCustomDetectionRuleRequest: CreateCustomDetectionRuleRequest,
): string {
  return JSON.stringify(
    CreateCustomDetectionRuleRequest$outboundSchema.parse(
      createCustomDetectionRuleRequest,
    ),
  );
}
